import { Capacitor } from '@capacitor/core';
import { Sentry } from '@/sentry';
import {
  breadcrumb,
  captureFailure,
  log,
  warn,
} from '@/lib/appTelemetry';

/** Sentry wrappers for flight-recorder GPS diagnostics. Never throw — recording must not depend on telemetry. */

export function recorderBreadcrumb(message: string, data?: Record<string, unknown>): void {
  breadcrumb('recorder', message, data);
}

export function recorderLog(message: string, data?: Record<string, unknown>): void {
  log('recorder', message, data);
}

export function reportGpsStall(data: { fixAgeMs: number; pointCount: number }): void {
  try {
    warn('recorder', 'gps-stall', {
      platform: Capacitor.getPlatform(),
      ...data,
    });
    Sentry.captureMessage('gps-stall', {
      level: 'warning',
      tags: { platform: Capacitor.getPlatform(), domain: 'recorder' },
      extra: data,
    });
  } catch {
    /* noop */
  }
}

export function reportGpsRecovered(data: { stallDurationMs: number; pointCount: number }): void {
  log('recorder', 'gps-recovered', {
    platform: Capacitor.getPlatform(),
    ...data,
  });
}

export function reportRecorderFailure(
  message: string,
  error?: unknown,
  data?: Record<string, unknown>,
): void {
  captureFailure('recorder', message, error, data);
}
